import {Injectable} from "@angular/core";
import {uuid} from '../utils/string-utils';

/**
 * This service provides storage and retrieval of the app user id
 */
@Injectable({providedIn: "root"})
export class AppUserService {
    public static readonly LOCAL_STORAGE_KEY: string = "appUserId";

    private readonly storageKey: string;

    constructor() {
        console.log("--- AppUserService");

        this.storageKey = AppUserService.LOCAL_STORAGE_KEY;
    }

    public getAppUserId(): string {
        let appUserId: string = localStorage.getItem(this.storageKey);
        if (appUserId == null) {
            appUserId = uuid();
            localStorage.setItem(this.storageKey, appUserId);
        }

        return appUserId;
    }

    public updateAppUserId(appUserId: string): void {
        localStorage.setItem(this.storageKey, appUserId);
    }
}
